
import { defineComponent, PropType, ref } from 'vue'
import GreetingCard from '@/components/GreetingCard.vue'
import PersonalityButton from '../common/PersonalityButton.vue'
export default defineComponent({
  components: {
    GreetingCard,
    PersonalityButton
  },

  emits: ['retry'],

  setup (props, { emit }) {
    function retryHandler () {
      emit('retry')
    }

    return {
      retryHandler
    }
  }
})
